

































import { Vue, Component } from 'vue-property-decorator';
import InquiryReasonModel from "../../js/dataModels/PetOwnerInquiry/inquiryReasonModel";
import PetDetails from "./petDetails.vue";
import NonHealthService from "./nonHealthService.vue";

@Component({
    name: 'petOwnerInquiry',
    components: { PetDetails, NonHealthService },
})

export default class PetOwnerInquiry extends Vue {
    serviceId: string;
    alertVisible: boolean = false;
    editorVisible: boolean = true;
    autoSelectPetHealthReason: boolean = false;
    petDetailsVisible: boolean = false;
    nonHealthMessageVisible: boolean = false;
    inquiryReasons: InquiryReasonModel[];
    selectedReason: InquiryReasonModel | null = null;
    servicePathId: number = 0;
    startChatVisible: boolean = false;
    requestCallbackVisible: boolean = false;
    nonHealthMessage: string = "";
    headers = { "Content-Type": "application/json;charset=utf-8" };

    constructor() {
        super();
        this.inquiryReasons = [];
        this.serviceId = (window as any).ServiceId;
        const thisWindow: any = window;
        if (thisWindow && thisWindow.AccessKey) {
            this.headers["Authorization"] = thisWindow.AccessKey;
            if (thisWindow.SelectPetHealthReason) {
                this.editorVisible = false;
                this.autoSelectPetHealthReason = true;
            }
        }
   }

    created(): void {
        this.initializeInquiryReasons();
    };

    initializeInquiryReasons(): void {
        if (!this.serviceId) {
            return;
        }
        var apiUrl = Vue.prototype.$rootApiPath + "PetOwnerInquiry/reasons/" + this.serviceId;
        this.$http.get(apiUrl, { headers: this.headers }).then((event: any): void => {
            this.inquiryReasons = event.body;
            if (this.autoSelectPetHealthReason) {
                const petHealthReason = this.inquiryReasons.find(r => r.petHealth);
                this.selectedReason = petHealthReason ? petHealthReason : null;
                if (this.selectedReason) {
                    this.onInquiryReasonChange();
                }
            }
        }, this.dataReadFailure);
    }

    dataReadFailure(event: any): void {
        let msg = "Error Processing Request";
        let title = "Error";

        if (event) {
            if (event.body) {
                if (event.body.detail) {
                    msg = event.body.detail;
                } else {
                    if (event.body.title) {
                        msg = event.body.title;
                    }
                }
            } else {
                if (event.bodyText) {
                    msg = event.bodyText;
                }
            }
        }

        this.showAlert(title, msg);
    }

    showAlert(title: string, msg: string): void {
        this.$nextTick(() => { this.$emit("alertModal/setData", title, msg); });
        this.alertVisible = true;
    }

    hideAlert(): void {
        this.alertVisible = false;
    }

    hideEditor(): void {
        this.editorVisible = false;
    }

    onInquiryReasonChange(): void {
        this.nonHealthMessageVisible = false;
        this.nonHealthMessage = "";
        this.petDetailsVisible = false;
        this.servicePathId = 0;
        this.startChatVisible = false;
        this.requestCallbackVisible = false;
        if (this.selectedReason) {
            if (this.selectedReason.petHealth) {
                this.servicePathId = this.selectedReason.id;
                this.startChatVisible = this.selectedReason.liveChat;
                this.requestCallbackVisible = this.selectedReason.requestCallback;
                this.petDetailsVisible = true;
            } else {
                this.nonHealthMessage = this.selectedReason.nonHealthMessage;
                this.nonHealthMessageVisible = true;
            }
        }
    }
}
